module.exports = "/*# sourceMappingURL=src/app/admin/admin-products/admin-categories/admin-categories.component.css.map */"